import { CombineCallsFunction } from './custom-crud-types';
import { Exception } from '../../models';
import { put } from './put';

export function updateItemFactory<TYPE>({
  preprocessCall = async (item) => item,
  postprocessCall = (data, response) => {
    if (!response?.ok) {
      throw { message: (data as Exception).message ?? 'Uložení selhalo.' };
    }
  },
  combineGetCalls = async ({ mainItem }) => ({ data: mainItem, text: '' }),
}: {
  preprocessCall?: (item: TYPE) => Promise<any>;
  postprocessCall?: (item: TYPE | Exception, response: Response) => void;
  combineGetCalls?: CombineCallsFunction;
}) {
  return function updateItem(api: string, item: TYPE) {
    const controller = new AbortController();
    const signal = controller.signal;

    return {
      abort: () => controller.abort(),
      response: new Promise<Response>(() => {}),
      json: async () => {
        const processedItem = await preprocessCall(item);

        const [json, response] = await put({
          url: `${api}/${(item as any).id}`,
          item: processedItem,
          signal,
        });

        postprocessCall(json!, response!);

        const { data } = await combineGetCalls({
          api,
          itemId: (item as any).id,
          signal,
          mainItem: json,
        });

        return data;
      },
      // not needed
      raw: async () => new Promise<Response>(() => {}),
      text: async () => {},
      none: async () => {},
    };
  };
}
